export const SYSTEM_PARTY_ID = "5ffebb3a1764860011ade9b4";
